<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page

========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert v-if="errorOccurred" color="danger" title="User Not Found">
      <span>Group record with id:  not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'admin-list-group'}"
                                        class="text-inherit underline">All Groups</router-link>
      </span>
    </vs-alert>

    <div v-if="group_data" id="group-data">

      <!-- Avatar -->
      <div class="vx-row match-height">


        <div class="vx-col lg:w-5/12 w-full">
          <!-- Avatar Col -->
          <vx-card class="mb-base" title="Group Overview">
            <div class="vx-row">
              <!-- Information - Group Information -->
              <vs-avatar :color="group_data.color" :text="group_data.name.charAt(0).toUpperCase()"  class="flex-shrink-0 ml-4 mr-4 font-bold mt-5"  size="60px" />

              <div id="account-info-col-1" class="vx-col flex-1 mb-4">
                <table>
                  <tr>
                    <td class="font-semibold">ID</td>
                    <td>{{ group_data.id }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Name</td>
                    <td>{{ group_data.name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Status</td>
                    <td>{{ group_data.status | capitalize }}</td>
                  </tr>
                </table>
              </div>

              <!-- /Information - Col 2 -->
              <div id="account-manage-buttons" class="vx-col w-full flex">
                <vs-button :to="{name: 'admin-edit-group', params: { groupId: group_data.id }}"
                           class="mr-4" icon="icon-edit"
                           icon-pack="feather">Edit
                </vs-button>
                <vs-button color="danger" icon="icon-trash" icon-pack="feather" type="border"
                           @click="confirmDeleteGroup">Archive
                </vs-button>
              </div>
            </div>
          </vx-card>
        </div>

        <div class="vx-col lg:w-5/12 w-full">
          <!-- Textarea Group Description -->
          <vx-card class="mb-base" title="Group Description">
            <vs-textarea v-model="group_data.description" :counter-danger.sync="group_description_counter"
                         counter="400" disabled height="230px"/>
          </vx-card>
        </div>


        <div class="vx-col lg:w-2/12 w-full">
          <vx-card class="mb-base" title="Group Actions">
            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-button class="w-full my-2 font-bold" color="success" icon="icon-user" icon-pack="feather"
                           type="filled" :disabled="true"
                           @click="showAlert('This Feature Is Currently Disabled')">Assign Student to
                  Group (Disabled)
                </vs-button>
                <vs-button class="w-full my-2 font-bold" color="success" icon="icon-user" icon-pack="feather"
                           type="filled" :disabled="true"
                           @click="reportPopup = !reportPopup">Generate Report (Disabled)
                </vs-button>
              </div>
            </div>
          </vx-card>
        </div>


      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <list-user :groupId="group_data.id" title="Group Users"/>
        </div>
      </div>


      <vs-popup :active.sync="reportPopup" :title="`Generate Report`">
        <div v-if="reportStep === 0">
          <h3>Choose Report <span class="font-bold">Starting Date</span></h3>
          <datepicker :inline="true" placeholder="Select Date" v-model="reportOptions.starting_date" class="datepicker-group-popup mt-4"></datepicker>
          <ul class="flex mt-5" :key="reportStep">
            <li>
              <vs-radio v-model="reportOptions.starting_date" @input="reportOptions.starting_date = new Date(0)" vs-value="0" class="mr-4">No Starting Date</vs-radio>
            </li>
            <li>
              <vs-radio v-model="reportOptions.starting_date" @input="reportOptions.starting_date = new Date()" :vs-value="Date.now()"  class="mr-4">Today</vs-radio>
            </li>
          </ul>
        </div>


        <div v-if="reportStep === 1">
          <h3>Choose Report <span class="font-bold">Ending Date</span></h3>
          <datepicker :inline="true" placeholder="Select Date" v-model="reportOptions.ending_date" class="datepicker-group-popup mt-4"></datepicker>
          <ul class="flex mt-5" :key="reportStep">
            <li>
              <vs-radio v-model="reportOptions.ending_date" @input="reportOptions.ending_date = new Date(2682392400000)" vs-value="2682392400000" class="mr-4">No Ending Date</vs-radio>
            </li>
            <li>
              <vs-radio v-model="reportOptions.ending_date" @input="reportOptions.ending_date = new Date()" :vs-value="Date.now()"  class="mr-4">Today</vs-radio>
            </li>
          </ul>
        </div>

        <div v-if="reportStep === 2" class="search-group-courses">
          <vs-table :data="reportCourses.results" :sst="true" max-items="5" search
                    @search="reportCoursesSearch">
            <template slot="header">
              <h3 class="ml-4">Select Courses</h3>
            </template>

            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Name</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(attach) in data" :key="attach.id">

                <vs-td :data="attach.id">
                  {{ attach.id }}
                </vs-td>

                <vs-td :data="`${attach.name}`">
                  <div class="flex align-middle items-center">
                    <img :src="attach.thumbnail" class="rounded mr-3" width="40px">
                    {{ `${attach.name}` }}
                  </div>
                </vs-td>

                <vs-td>
                  <vs-button color="primary" size="small" type="border" @click="reportCoursesAssign(attach)" v-if="!reportCourses.selected.includes(attach)" style="min-width: 85px;">
                    Assign
                  </vs-button>
                  <vs-button color="danger" size="small" type="border" @click="reportCoursesRemove(attach)" v-if="reportCourses.selected.includes(attach)" style="min-width: 85px;">
                    Remove
                  </vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div v-if="reportStep === 3" class="search-group-courses">
          <h3 class="mb-2">Starting Date : {{(new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'long', day: 'numeric',})).format(reportOptions.starting_date)}}</h3>
          <h3 class="mb-2">Ending Date : {{(new Intl.DateTimeFormat('en-US', {year: 'numeric', month: 'long', day: 'numeric',})).format(reportOptions.ending_date)}}</h3>
          <vs-divider/>
          <vs-table :data="reportCourses.selected" max-items="5" pagination class="mt-2">
            <template slot="header">
              <h3 class="mb-5">Selected Courses</h3>
            </template>

            <template slot="thead">
              <vs-th>Id</vs-th>
              <vs-th>Name</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr v-for="(attach) in data" :key="attach.id">

                <vs-td :data="attach.id">
                  {{ attach.id }}
                </vs-td>

                <vs-td :data="`${attach.name}`">
                  <div class="flex align-middle items-center">
                    <img :src="attach.thumbnail" class="rounded mr-3" width="40px">
                    {{ `${attach.name}` }}
                  </div>
                </vs-td>

                <vs-td>
                  <vs-button color="danger" size="small" type="border" @click="reportCoursesRemove(attach)" v-if="reportCourses.selected.includes(attach)" style="min-width: 85px;">
                    Remove
                  </vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>

        <div class="flex items-center mt-6">
          <vs-button class="shadow-lg mr-2" color="danger" icon="icon-arrow-left" icon-pack="feather"
                     :disabled="reportStep === 0" @click="nextReportStep('previous')">Previous Step
          </vs-button>
          <vs-button class="shadow-lg" color="success" icon="icon-arrow-right" icon-pack="feather" icon-after
                     :disabled="reportStep === 3" @click="nextReportStep('next')" v-if="reportStep !== 3">Next Step
          </vs-button>
          <vs-button class="shadow-lg" color="success" icon="icon-download" icon-pack="feather" icon-after
                     @click="generateReport" v-if="reportStep === 3" :disabled="reportGenerating">Generate Report
          </vs-button>
        </div>


      </vs-popup>

    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>

  </div>
</template>

<script>
import Prism from 'vue-prism-component'
import ListUser from '../../../users/admin/user-list/ListUser'
import Datepicker from 'vuejs-datepicker'

export default {
  data () {
    return {
      group_data: null,

      add_simulation_selected: [],
      add_simulation_popup_active: false,
      add_simulation_search_query: null,

      add_student_search_active: false,
      add_student_assign_active: false,
      add_student_search_results: [],
      add_student_assign_user: {},
      add_student_assign_user_duration: null,

      group_description_counter: false,

      reportPopup: false,
      reportStep: 0,
      reportDates: {
        ending_date: null,
        starting_date: null
      },
      reportCourses: {
        results: [],
        selected: []
      },
      reportOptions: {
        starting_date: null,
        ending_date: null,
        courses: []
      },
      reportGenerating: false,

      errorOccurred: false
    }
  },
  components: {
    Prism,
    ListUser,
    Datepicker
  },
  methods: {
    showAlert (message) {
      alert(message)
    },
    fetchGroupDetails (id) {

      this.$http.get(`groups/${id}`)
        .then(response => {

          if (response.status === 200) {
            this.group_data = response.data.data
          }

        })
        .catch(error => {
          this.errorOccurred = true
          this.error_msg = error
        })
    },
    confirmDeleteGroup () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Archive',
        text: 'Please confirm you want to archive this group.',
        accept: this.deleteGroup,
        acceptText: 'Archive'
      })
    },
    deleteGroup () {
      this.$vs.loading()

      this.$http.delete(`groups/${this.$route.params.groupId}`)
        .then(response => {
          this.$vs.loading.close()

          if (response.status === 200) {
            this.$router.push('/a/groups')

            return this.$vs.notify({
              color: 'success',
              title: 'Group Archived',
              text: 'You have successfully archived this group',
              icon: 'feather',
              iconPack: 'icon-check-circle',
              position: 'top-right'
            })
          }
        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while deleting this group.'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Delete Group',
            text: error,
            icon: 'feather',
            iconPack: 'icon-x-circle',
            position: 'top-right'
          })
        })
    },
    addStudentUserSearch (term) {
      if (!term) return
      this.$http.get(`users?search=${term}&amount=5`)
        .then(response => {
          if (response.data) {
            this.add_student_search_results = response.data.data

          }
        })
    },
    addStudentToGroupOptions (id) {

      this.add_student_search_active = false
      this.add_student_assign_active = true
      this.add_student_assign_user = id
      this.add_student_assign_user.profile_picture =  this.add_student_assign_user.profile_picture !== null ? this.add_student_assign_user.profile_picture : 'default'

    },
    generateReport () {

      this.reportOptions.courses = []
      this.reportGenerating = true


      this.$vs.notify({
        color: 'warning',
        title: 'Report Generating',
        text: 'Your report will begin downloading shortly.',
        position: 'top-right'
      })

      this.reportCourses.selected.forEach(item => {
        this.reportOptions.courses.push(item.id)
      })

      const pl = {
        starting_date: this.reportOptions.starting_date.getTime(),
        ending_date: this.reportOptions.ending_date.getTime(),
        courses: this.reportOptions.courses
      }

      this.$http.post(`progress/group/reports/${this.group_data.id}/mass/excel`, pl)
        .then(response => {
          if (response.status === 200) {
            this.$vs.notify({
              color: 'success',
              title: 'Report Generated',
              text: 'Your report has successfully been created.',
              position: 'top-right'
            })

            this.reportGenerating = false
            return location.replace(`https://sims-api.intellectualpoint.com/reports/${  response.data.data  }.xlsx`)

          }
        }).catch(exception => {
          this.reportGenerating = false
          return this.$vs.notify({
            color: 'danger',
            title: 'Failed to Generate Report',
            text: exception.response.data.error.description,
            position: 'top-right'
          })
        })
    },
    nextReportStep (val) {
      if (val === 'previous') {
        return this.reportStep--
      }
      if (val === 'next') {
        if (this.reportStep === 0 && this.reportOptions.starting_date === null) {
          return this.$vs.notify({color: 'danger', title: 'Missing Report Starting Date', text: 'Please select the report starting date before proceeding.', position: 'top-right'
          })
        }
        if (this.reportStep === 1 && this.reportOptions.ending_date === null) {
          return this.$vs.notify({color: 'danger', title: 'Missing Report Ending Date', text: 'Please select the report starting date before proceeding.', position: 'top-right'
          })
        }
        if (this.reportStep === 2 && this.reportCourses.selected.length === 0) {
          return this.$vs.notify({color: 'danger', title: 'No Courses Selected', text: 'You must select a minimum of 1 courses to generate a report.', position: 'top-right'
          })
        }
        return this.reportStep++
      }

    },
    reportCoursesSearch (term) {
      this.$http.get(`courses?search=${term}&amount=5`)
        .then(response => {
          if (response.data) {
            this.reportCourses.results = response.data.data
          }
        })
    },
    reportCoursesAssign (course) {
      this.reportCourses.selected.push(course)
    },
    reportCoursesRemove (course) {
      this.reportCourses.selected.forEach((item, index) => {
        if (item.id === course.id) {
          this.reportCourses.selected.splice(index, 1)
        }
      })
    }
  },
  created () {
    this.fetchGroupDetails(this.$route.params.groupId)
    this.reportCoursesSearch('')
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 15rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

.search-group-courses {
  input.input-search.vs-table--search-input {
    border: 1px solid rgb(255 255 255)!important;
  }
}

.datepicker-group-popup {
  .vdp-datepicker__calendar {
    width: 100%;
    padding: 5px 0 10px 0;
  }


  span.cell.day {
    border-radius: 5%;
    margin-bottom: 0.5%;
    margin-top: 0.5%;
  }

  span.cell.day.today {
    border-radius: 5%;
    color: #fff;
    background: rgba(var(--vs-primary), 0.1);

    &:hover {
      background: rgba(var(--vs-primary), 0.2);
    }
  }
}
</style>
